type Params = Record<string, unknown>;

type Request = {
  path: string;
  config?: RequestInit;
  params?: Params;
};

type RequestWithBody<B> = {
  body: B;
} & Request;

export class APIWrapper {
  getEndpoint(path: string, params?: Params) {
    const url = new URL(path);

    if (params) {
      for (const [key, value] of Object.entries(params)) {
        url.searchParams.append(key, `${value}`);
      }
    }

    return url.toString();
  }

  async http<Response>(path: string, config: RequestInit, params?: Params): Promise<Response> {
    const endpoint = this.getEndpoint(path, params);

    try {
      const response = await fetch(endpoint, config);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async get<Response>({ config, path, params }: Request): Promise<Response> {
    const init = { method: 'GET', ...config };
    return await this.http<Response>(path, init, params);
  }

  async post<Body, Response>({
    config,
    body,
    path,
    params,
  }: RequestWithBody<Body>): Promise<Response> {
    const init = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      ...config,
    };

    return await this.http<Response>(path, init, params);
  }

  async delete<Body, Response>({
    config,
    body,
    path,
    params,
  }: RequestWithBody<Body>): Promise<Response> {
    const init = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      ...config,
    };

    return await this.http<Response>(path, init, params);
  }
}

export const API = new APIWrapper();
